module.exports = __webpack_public_path__ + "img/40.476a2e64.jpg";